var map = {
	"./caishijieLogo.png": "1ffd",
	"./caishujuLogo.png": "64f3",
	"./cqsscLogo.png": "f437",
	"./gd10Logo.png": "a745",
	"./liuheLogo.png": "86be",
	"./madouLogo.png": "b0a5",
	"./pcddLogo.png": "4e03",
	"./pk10Logo.png": "55f3",
	"./xyftLogo.png": "4e34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a67";